import axios from '@/axios.config.js';

class UserService {
    addFullNameToUser(user) {
        user.full_name =
            user.first_name && user.last_name ? `${user.first_name} ${user.last_name}` :
                (
                    user.first_name && !user.last_name ? user.first_name :
                        (
                            !user.first_name && user.last_name ? user.first_name :
                                user.phone?.replace('+98', '0')
                        )
                )
    }

    createUser(cancelToken, user) {
        return axios
            .post(`roles/${user.role_id}/users`, {
                first_name: user.first_name,
                last_name: user.last_name,
                national_id: user.national_id,
                phone: user.phone,
                school_id: user.school_id,
                info: user.info
            }, {cancelToken: cancelToken.token})
            .then(response => {
                this.addFullNameToUser(response.data)
                return response.data;
            });
    }

    updateUser(cancelToken, user) {
        return axios
            .patch(`users/${user.id}`, {
                first_name: user.first_name,
                last_name: user.last_name,
                school_id: user.school_id,
                grade: user.grade,
                info: user.info,
            }, {cancelToken: cancelToken.token})
            .then(response => {
                this.addFullNameToUser(response.data)
                return response.data;
            });
    }

    deleteUser(cancelToken, userId) {
        return axios
            .delete(`users/${userId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    getUser(cancelToken, userId) {
        return axios
            .get(`users/${userId}`, {cancelToken: cancelToken.token})
            .then(response => {
                this.addFullNameToUser(response.data)
                return response.data;
            });
    }

    listUsersByRole(roleNameOrId) {
        return axios
            .get(`/admin/roles/${roleNameOrId}/users`)
            .then(response => {
                for (const user of response.data) {
                    this.addFullNameToUser(user)
                }
                return response.data;
            });
    }

    listStudentsForConsultant(cancelToken) {
        return axios
            .get('/consultants/students', {cancelToken: cancelToken.token})
            .then(response => {
                for (const user of response.data.students) {
                    this.addFullNameToUser(user)
                }
                return response.data
            })
    }

    adminListStudentsForConsultant(cancelToken, consultantId) {
        return axios
            .get(`/consultants/${consultantId}/students`, {cancelToken: cancelToken.token})
            .then(response => {
                for (const user of response.data.students) {
                    this.addFullNameToUser(user)
                }
                return response.data
            })
    }

    syncStudentsForConsultant(cancelToken, consultantId, data) {
        return axios
            .post(`/consultants/${consultantId}/students`, data, {cancelToken: cancelToken.token})
            .then(response => {
                for (const user of response.data.students) {
                    this.addFullNameToUser(user)
                }
                return response.data
            })
    }

    listUserComments(cancelToken, userId) {
        return axios
            .get(`/users/${userId}/comments`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data
            })
    }

    createUserComment(cancelToken, userId, data) {
        return axios
            .post(`/users/${userId}/comments`, data, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data
            })
    }

    deleteUserComment(cancelToken, userId, commentId) {
        return axios
            .delete(`/users/${userId}/comments/${commentId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data
            })
    }

}

export default new UserService();
